module.exports = __webpack_public_path__ + "img/gcm.6b8bbcd0.png";